import React, { createContext, useEffect, useRef } from "react";
import logo from "./logo.svg";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import logger from "./utils/logger";
import Employees from "./pages/employees";
import Dashboard from "./pages/dashboard";
import DashboardAnalytics from "./pages/dashboard-analytics";
import Employee from "./pages/employee";
import Projects from "./pages/projects";
import Settings from "./pages/settings";
import Directory from "./pages/directory";

import { useAuth0 } from "@auth0/auth0-react";
import Landing from "./landing";
import UserContext from "./components/TheUser";
import DefaultLayout from "./layout/default";
import Login from "./login";
import NotFound from "./404";

import { useIdleTimer } from "react-idle-timer";

import NewEmployee from "./pages/newEmployee";
import ImportEmployees from "./pages/importEmployees";
import Profile from "./pages/profile";
import Reports from "./pages/reports";
import Payments from "./pages/payments";
import FinanceReport from "./pages/report/financeReport";
import Timesheet from "./pages/timesheet";
import Payroll from "./pages/payroll";
import NewPayroll from "./pages/newPayroll";
import TheEmployee from "./pages/theEmployee";
import Test from "./pages/test";
import AccountReceivableByUser from "./pages/report/payments/account-receivable-by-user";
import AccountReceivableByMonth from "./pages/report/payments/account-receivable-by-month";
import AccountReceivableIkat from "./pages/report/payments/account-receivable-ikat";
import AccountReceivableRt from "./pages/report/payments/account-receivable-rt";
import OutstandingPayments from "./pages/report/outstanding-payments";
import YTDStatement from "./pages/report/payroll/ytd-statement";
import PayrollDetails from "./pages/report/payroll/payroll-details";
import PayrollSummary from "./pages/report/payroll/payroll-summary";
import MonthlySnapshotReport from "./pages/report/payroll/monthly-snapshort-report";
import Invoices from "./pages/report/payments/invoices";
import Invoice from "./pages/report/payments/invoice";
import BulkPayments from "./pages/report/payments/bulk";
import AdjustPayments from "./pages/report/payments/adjust";
import WorkingDays from "./pages/report/payments/working-days";
import PaymentStatus from "./pages/report/payments/status";
import TimesheetDetails from "./pages/timesheetDetails";
import PayrollItem from "./pages/payrollItem";
import ImportPayroll from "./pages/importPayroll";
import TimesheetResourcsewise from "./pages/report/timesheet/timesheetResourcsewise";
import TimesheetMonthwise from "./pages/report/timesheet/timesheetMonthwise";
import BulkInsertResource from "./pages/report/timesheet/bulkInsertResource";
import Client from "./pages/client";
import ProtectedRoute from "./ProtectedRoute";
import TimesheetEditor from "./pages/timesheet-editor";
import PayrollEditor from "./pages/payrollEditor";
import TimesheetWeeklyResourcewise from "./pages/report/timesheet/timesheetWeeklyResourcewise";
import TimesheetFortnightlyResourcewise from "./pages/report/timesheet/timesheetFortnightlyResourcewise";
import LCAStatement from "./pages/report/lca-statement";
function App() {
    const { isAuthenticated, user, loginWithRedirect, logout, loginWithPopup } = useAuth0();


    const idleTimerRef = useRef(null);

    const onIdle = () => {
        try {
            if (isAuthenticated) {
                console.log("Idle timer triggered at:", new Date());
                logout({ logoutParams: { returnTo: window.location.origin } });
            }
        } catch (error) {
            logger.error("Error during idle logout:", {}, error);
        }
    };

    useIdleTimer({
        ref: idleTimerRef,
        timeout: 1000 * 60 * 30,
        onIdle,
        debounce: 1000,
        element: document,
        events: [
            "mousemove",
            "keydown",
            "mousedown",
            "touchstart",
        ],
    });

    return (
        <>
                <UserContext.Provider value={{ user: user }}>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/landing" element={<Landing />} />
                        {/* <Route path="*" element={<PageNotFound />} /> */}
                        {/* <Route path="/login" element={<Login />} /> */}

                        <Route element={<DefaultLayout />}>
                            <Route
                                path="/home"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Dashboard">
                                            <Dashboard />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Dashboard">
                                            <Dashboard />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/dashboard-analytics"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="DashboardAnalytics">
                                            <DashboardAnalytics />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/employees"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Employees">
                                            <Employees />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/employees/:handle"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Employee">
                                            <Employee />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/employee/:handle"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="TheEmployee">
                                            <TheEmployee />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/employees/new"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="NewEmployee">
                                            <NewEmployee />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/employees/import"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="ImportEmployees">
                                            <ImportEmployees />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/clients"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Client">
                                            <Client />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/projects/:cid"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Projects">
                                            <Projects />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/projects"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Projects">
                                            <Projects />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Settings">
                                            <Settings />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                        

                            <Route
                                path="/payments"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Payments">
                                            <Payments />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            {/* <Route
                                path="/payments/receivable/user"
                                element={
                                    <ProtectedRoute>
                                        <AccountReceivableByUser />
                                    </ProtectedRoute>
                                }
                            /> */}
                            <Route
                                path="/payments/receivable/month"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="AccountReceivableByMonth">
                                            <AccountReceivableByMonth />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/receivable/ikat"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="AccountReceivableIkat">
                                            <AccountReceivableIkat />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/receivable/rt"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="AccountReceivableRt">
                                            <AccountReceivableRt />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/payments/outstanding"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="OutstandingPayments">
                                            <OutstandingPayments />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/payments/invoice"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Invoices">
                                            <Invoices />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/invoice/:uuid/:_invNo"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Invoice">
                                            <Invoice />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/invoice/:uuid/:_m/:_y/:_invNo/:_d"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Invoice">
                                            <Invoice />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/invoice/:uuid/:_w/:_m/:_y/:_invNo/:_d"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Invoice">
                                            <Invoice />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/payments/bulk"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="BulkPayments">
                                            <BulkPayments />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/adjust"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="AdjustPayments">
                                            <AdjustPayments />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/working-days"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="WorkingDays">
                                            <WorkingDays />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payments/status"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="PaymentStatus">
                                            <PaymentStatus />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/test"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Test">
                                            <Test />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/reports"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Reports">
                                            <Reports />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/reports/finance"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="FinanceReport">
                                            <FinanceReport />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Profile">
                                            <Profile />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/payroll"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Payroll">
                                            <Payroll />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/new"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="NewPayroll">
                                            <NewPayroll />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/ytd"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="YTDStatement">
                                            <YTDStatement />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/month"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="MonthlySnapshotReport">
                                            <MonthlySnapshotReport />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/summary"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="PayrollSummary">
                                            <PayrollSummary />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/detail"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="PayrollDetails">
                                            <PayrollDetails />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/:uuid"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="PayrollItem">
                                            <PayrollItem />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/payroll/import"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="ImportPayroll">
                                            <ImportPayroll />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/timesheet"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="Timesheet">
                                            <Timesheet />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            {/* <Route
                                path="/timesheet/statement/user"
                                element={
                                    <ProtectedRoute>
                                        <TimesheetResourcsewise />
                                    </ProtectedRoute>
                                }
                            /> */}
                            <Route
                                path="/timesheet/statement/month"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="TimesheetMonthwise">
                                            <TimesheetMonthwise />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/timesheet/statement/week"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="TimesheetWeeklyResourcewise">
                                            <TimesheetWeeklyResourcewise />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/timesheet/statement/fortnight"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="TimesheetFortnightlyResourcewise">
                                            <TimesheetFortnightlyResourcewise />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/timesheet/statement/lca"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="LCAStatement">
                                            <LCAStatement />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/timesheet/:uuid"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="TimesheetDetails">
                                            <TimesheetDetails />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/timesheet/bulkInsert"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="BulkInsertResource">
                                            <BulkInsertResource />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/payroll/editor/:uuid"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="PayrollEditor">
                                            <PayrollEditor />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/timesheet/editor/:uuid"
                                element={
                                    <ProtectedRoute>
                                        <ErrorBoundary name="TimesheetEditor">
                                            <TimesheetEditor />
                                        </ErrorBoundary>
                                    </ProtectedRoute>
                                }
                            />

                            {/* <Route path="/timesheet" element={<Timesheet />} /> */}
                            {/* <Route path="/directory" element={<Directory />} /> */}
                        </Route>

                        <Route path="*" element={<NotFound />} />

                        {/* 
                            {/* <Route path="/information" element={<Information />} />
                            <Route path="/profile" element={<Profile />} />
                    */}
                    </Routes>
                </UserContext.Provider>
        </>
    );
}

export default App;
